import React, { useEffect } from "react"
import { useI18next } from "gatsby-plugin-react-i18next"
import { PageProps, graphql } from "gatsby"

import { routeParams, routes } from "../routes"
import { useAnonymousAPI } from "../services/api"
import { SEO } from "../components/SEO"

const Home = ({ params }: PageProps) => {
  const { navigate, changeLanguage, language } = useI18next()
  const anonymousAPI = useAnonymousAPI()

  useEffect(() => {
    const redirectToCountryCodeRoute = async () => {
      let countryCode = params[routeParams.countryCode]
      if (!countryCode) {
        countryCode = await anonymousAPI.other.getCountryCode()
      }
      navigate(routes.restaurants(countryCode))
    }

    // if browser language is same as gatsby-plugin-react-i18next default language,
    // it will serve a route without locale
    // this is a way to force the route that includes the locale
    if (language === "en" && !window.location.pathname.includes("/en")) {
      changeLanguage("en")
      return
    }

    // URL country code support logic
    redirectToCountryCodeRoute()
  }, [params[routeParams.countryCode]])

  return <></>
}

export default Home

export const Head = () => (
  <SEO
    title={process.env.GATSBY_PARTNER_TITLE || ""}
    description={process.env.GATSBY_PARTNER_DESCRIPTION || ""}
    image={process.env.GATSBY_LOGO || ""}
  />
)

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
